import { useEffect, useState } from "react";
import { Instrument, UpdateInstrumentInput } from "../../API";
import { QueryStatus } from "../../app/types";
import {
  fetchInstrument,
  updateInstrument as updateInstrumentAPI
} from "./instrumentsAPI";

export const useInstrument = (id?: string) => {
  const [instrument, setInstrument] = useState<Instrument | null>(null);
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const getInstrument = async (id: string): Promise<Instrument | null> => {
    setStatus("loading");
    setError(null);

    try {
      const result = await fetchInstrument(id);
      setInstrument(result);
      setStatus("succeeded");
      return result;
    } catch (error) {
      console.error("error fetching instrument:", error);
      setStatus("failed");
      setError(JSON.stringify(error));
    }
    return null;
  };

  useEffect(() => {
    if (id) {
      getInstrument(id);
    }
  }, [id]);

  return {
    instrument,
    status,
    error,
    getInstrument
  };
};

export const useUpdateInstrument = () => {
  const [updatedInstrument, setUpdatedInstrument] = useState<Instrument | null>(
    null
  );
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const updateInstrument = async (input: UpdateInstrumentInput) => {
    setStatus("loading");
    setError(null);

    try {
      const creationResult = await updateInstrumentAPI(input);
      setUpdatedInstrument(creationResult);
      setStatus("succeeded");
      return creationResult;
    } catch (error) {
      console.error("error in createAnswerOption:", error);
      const errorString = JSON.stringify(error);
      setStatus("failed");
      setError(errorString);
    }
    return null;
  };
  return {
    updatedInstrument,
    status,
    error,
    updateInstrument
  };
};

// Dev Note: Some of these will have overlap until we get direction about what the error text should be from product.

export const InstrumentErrors = {
  NoTitle: "Title is required."
};

export const QuestionErrors = {
  NoSortingIndex: "Sorting Index is required.",
  NoTitle: "Title is required"
};

export const AnswerOptionErrors = {
  NoSortingIndex: "Sorting Index is required.",
  NoAnchor: "Anchor is required.",
  NoValue: "Value is required."
};
